<template>
    <div 
        :class="[
            'tw:relative tw:flex tw:items-center tw:gap-4 tw:p-4 tw:rounded-xl tw:border-2 tw:transition-all tw:duration-200',
            disabled ? 'tw:opacity-50 tw:cursor-not-allowed' : 'tw:cursor-pointer',
            active 
                ? `${variants[variant].bg} ${variants[variant].border} tw:shadow-sm` 
                : 'tw:bg-white tw:border-gray-100 hover:tw:border-gray-200'
        ]"
        @click="!disabled && $emit('click')"
    >
        <div 
            :class="[
                'tw:w-12 tw:h-12 tw:rounded-full tw:flex tw:items-center tw:justify-center tw:transition-colors',
                active ? variants[variant].iconBg : 'tw:bg-gray-100'
            ]"
        >
            <slot name="icon" :active="active">
                <i :class="[icon, 'tw:text-xl', active ? 'tw:text-white' : 'tw:text-gray-400']"></i>
            </slot>
        </div>
        <div class="tw:flex tw:flex-col">
            <span :class="['tw:text-sm tw:font-bold', active ? variants[variant].text : 'tw:text-gray-700']">
                {{ title }}
            </span>
            <span class="tw:text-xs tw:text-gray-400">
                {{ description }}
            </span>
        </div>
        <div 
            v-if="active"
            :class="['tw:absolute tw:top-3 tw:right-3 tw:w-5 tw:h-5 tw:rounded-full tw:flex tw:items-center tw:justify-center', variants[variant].iconBg]"
        >
            <i class="fas fa-check tw:text-white tw:text-[10px]"></i>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        active: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        variant: {
            type: String,
            default: 'primary',
            validator: value => ['primary', 'success', 'warning', 'danger', 'info'].includes(value)
        },
        disabled: {
            type: Boolean,
            default: false
        }
    });

    defineEmits(['click']);

    const variants = {
        primary: {
            bg: 'tw:bg-blue-50',
            border: 'tw:border-blue-500',
            iconBg: 'tw:bg-blue-500',
            text: 'tw:text-blue-700'
        },
        success: {
            bg: 'tw:bg-green-50',
            border: 'tw:border-green-500',
            iconBg: 'tw:bg-green-500',
            text: 'tw:text-green-700'
        },
        warning: {
            bg: 'tw:bg-yellow-50',
            border: 'tw:border-yellow-500',
            iconBg: 'tw:bg-yellow-500',
            text: 'tw:text-yellow-700'
        },
        danger: {
            bg: 'tw:bg-red-50',
            border: 'tw:border-red-500',
            iconBg: 'tw:bg-red-500',
            text: 'tw:text-red-700'
        },
        info: {
            bg: 'tw:bg-cyan-50',
            border: 'tw:border-cyan-500',
            iconBg: 'tw:bg-cyan-500',
            text: 'tw:text-cyan-700'
        }
    };
</script>
